import '@emotion/react';

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref = process.env.NODE_ENV === "production" ? {
  name: "1azakc",
  styles: "text-align:center"
} : {
  name: "1v1v0z5-getSectionLoadingStyles",
  styles: "text-align:center;label:getSectionLoadingStyles;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlBheW1lbnRPcHRpb25zU3R5bGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUdJIiwiZmlsZSI6IlBheW1lbnRPcHRpb25zU3R5bGVzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgY3NzLCBTZXJpYWxpemVkU3R5bGVzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuXG5leHBvcnQgY29uc3QgZ2V0U2VjdGlvbkxvYWRpbmdTdHlsZXMgPSAoKTogU2VyaWFsaXplZFN0eWxlcyA9PlxuICAgIGNzcyh7XG4gICAgICAgIHRleHRBbGlnbjogJ2NlbnRlcicsXG4gICAgfSk7XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
const getSectionLoadingStyles = () => _ref;

export { getSectionLoadingStyles };
//# sourceMappingURL=PaymentOptionsStyles.js.map
